export const boxStylesStyles = theme => ({
  '& > span': {
    marginTop: '1px',
    padding: 0,
  },
  '& > span > div': {
    marginBottom: 0,
  },
  '&:first-child': {
    marginRight: theme.spacing(0.5),
  },
  alignItems: 'center',
  borderRadius: 4,
  display: 'flex',
  height: 20,
  justifyContent: 'center',
  padding: 2,
  width: 30,
});

export const buttonStyles = theme => ({
  marginLeft: theme.spacing(2),
  position: 'relative',
});

export const headerStyles = theme => ({
  alignItems: 'center',
  display: 'flex',
  marginBottom: theme.spacing(3),
});

export const keyStyles = theme => ({
  '&:last-child': {
    marginRight: 0,
  },
  alignItems: 'center',
  columnGap: theme.spacing(1),
  display: 'grid',
  gridTemplateColumns: '30px auto',
  marginRight: theme.spacing(3),
});

export const parentStyles = {
  marginRight: 'auto',
  marginTop: 2,
};
